// @tessma:boundary-exempt no-marketing-plan-names — this file IS the deny list
// the rule enforces at the source-text level; it has to name what it rejects.
/**
 * Neutral commercial identifiers (C-4).
 *
 * > `plan_code`: `plan_a`, `plan_b` — never `"starter"`, `"professional"`,
 * > `"enterprise"`. Display names are catalogue data, assigned through
 * > configuration and localised per market.
 *
 * **Why this matters beyond tidiness.** Marketing names change, get localised,
 * get re-tiered and get retired. A code embedded in entitlement records, audit
 * events, usage meters and invoices must outlive all of that — and a code that
 * IS a marketing name becomes unremovable the moment the tier is renamed.
 *
 * The boundary rule `no-marketing-plan-names` catches these appearing in source
 * text; this catches them arriving as data at runtime, from a manifest or from
 * a grant. Two layers, one list, and the list lives here so there is only one.
 */
export const MARKETING_NAMES = [
    'starter',
    'basic',
    'standard',
    'professional',
    'pro',
    'business',
    'premium',
    'advanced',
    'enterprise',
    'ultimate',
    'plus',
    'lite',
    'free',
    'trial',
    'team',
];
export function isNeutralCommercialCode(code) {
    const normalised = code.toLowerCase();
    return !MARKETING_NAMES.some((name) => normalised.includes(name));
}
export class MarketingNameError extends Error {
    constructor(kind, code) {
        super(`${kind} code ${JSON.stringify(code)} reads as a marketing name. Use a neutral identifier ` +
            `(${kind === 'plan' ? 'plan_a' : 'ed_01'}) and hold the display name as catalogue data, ` +
            'so a rename stays a catalogue row rather than becoming a migration (C-4).');
        this.name = 'MarketingNameError';
    }
}
export function assertNeutralCommercialCode(kind, code) {
    if (!isNeutralCommercialCode(code))
        throw new MarketingNameError(kind, code);
}
//# sourceMappingURL=commercial-codes.js.map